
import Vue from "vue";
import CandidateAiInterviewReport from "@/views/candidate/interviews/CandidateAiInterviewReport.vue";

export default Vue.extend({
  name: "RecruiterAiInterviewReport",
  components: {
    CandidateAiInterviewReport
  }
});
